import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  IconButton,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Button,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";
// swipe
import SwipeableViews from "react-swipeable-views";

import { propertyDataArray } from "../components/PropertyDataArray";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_date_ymd_from: Date
    $obj_date_ymd_to: Date
    $obj_city: [String]
    $popular: Boolean
    $frontSite: Boolean
  ) {
    foreclosures(
      obj_date_ymd_from: $obj_date_ymd_from
      obj_date_ymd_to: $obj_date_ymd_to
      obj_city: $obj_city
      popular: $popular
      frontSite: $frontSite
    ) {
      count
      pageCount
      contents {
        obj_no
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_link
        obj_margin
        obj_price
        obj_price_set
        obj_creditor
        obj_debtor
        obj_bulletin_data
        obj_remark
        obj_land_data
        obj_build_data
        obj_land_floor
        obj_build_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_transfer
        obj_type
        obj_creat_date
        obj_stop
        obj_tender_num
        obj_tender
        obj_check_num
        obj_stop_link
        obj_source
        obj_marker
        obj_coordinates
        obj_request_num
        obj_cadastral
        obj_patterns
        obj_sql
        obj_pyPDF
        phppdfjoin
        images {
          id
          imageUrl
        }
      }
    }
  }
`;

const GET_EXCLUSIVEPROPERTIES = gql`
  query exclusiveProperties(
    $franchiseStoreId: Int!
    $enabled: Boolean
    $pageSize: Int
    $page: Int
  ) {
    exclusiveProperties(
      franchiseStoreId: $franchiseStoreId
      enabled: $enabled
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_link
        obj_margin
        obj_price
        obj_price_set
        obj_creditor
        obj_debtor
        obj_bulletin_data
        obj_remark
        obj_land_data
        obj_build_data
        obj_land_floor
        obj_build_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_transfer
        obj_type
        obj_creat_date
        obj_stop
        obj_tender_num
        obj_tender
        obj_check_num
        obj_stop_link
        obj_source
        obj_marker
        obj_coordinates
        obj_request_num
        obj_cadastral
        obj_patterns
        pricePerBuildPing
        pricePerLandPing
        obj_sql
        obj_pyPDF
        phppdfjoin
        errorLog
        lastEditedBy
        images {
          id
          imageUrl
        }
        imageHasCreated
        source
        name
        rent
        deposit
        managementFee
        monthOfManagementFee
        parkingSpace
        houseAge
        indoor_floor
        room
        hall
        bathroom
        orientation
        enable
      }
    }
  }
`;

const ADD_CHEACKNUMBER = gql`
  mutation addCheackNumber($id: Int!, $franchise: Boolean!) {
    addCheackNumber(id: $id, franchise: $franchise)
  }
`;

export default function ChoiceProperty({ franchise, onChangeTab = () => {} }) {
  const theme = useTheme();
  const history = useHistory();
  const Alert = useAlert();
  const isPhone = useMediaQuery("(max-width:600px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const isPc = useMediaQuery("(max-width:1200px)");
  const isSmPhone = useMediaQuery("(max-width:480px)");

  // 這邊
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    media: {
      height: 300,
    },
    cardTitle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 4,
      "-webkit-box-orient": "vertical",
    },
    ChoicePropertyTabsRoot: {
      position: "relative",
    },
    nextBtn: {
      position: "absolute",
      top: "50%",
      right: 2,
      transform: "scale(0.8) translateY(-50%)",
      zIndex: 10,
    },
    prevBtn: {
      position: "absolute",
      top: "50%",
      left: 2,
      transform: "scale(0.8) translateY(-50%)",
      zIndex: 10,
    },
    moreBtn: {
      display: isPc ? "none" : "block",
    },
    itemButton: {
      display: "inline-block",
    },
  }));
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { courtArray } = propertyDataArray();
  const sectionName = ["全部", "北部", "中部", "南部", "東部", "離島"];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // let sectionList = [];
  const [sectionList, setSectionList] = useState([]);
  const [getForeclosures, { loading }] = useLazyQuery(GET_FORECLOSURES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosures }) {
      let list = [];
      let newArray = [];
      foreclosures.contents.forEach((item) => {
        list.push({
          label:
            item.obj_type === "L"
              ? item.obj_city + item.obj_area + item.obj_section + "段"
              : getAddress(item.obj_city, item.obj_area, item.obj_address),
          obj_total_floor: item.obj_total_floor.toFixed(2),
          obj_land_floor: item.obj_land_floor.toFixed(2),
          obj_margin: (item.obj_margin / 10000).toFixed(2),
          obj_type: item.obj_type === "H" ? "建物" : "土地",
          obj_no: item.obj_no,
          obj_price: item.obj_price.toFixed(2),
          obj_court: item.obj_court,
          obj_str: item.obj_str,
          obj_share: item.obj_share,
          obj_caseno: item.obj_caseno,
          obj_city: item.obj_city,
          obj_area: item.obj_area,
          obj_address: item.obj_address,
          obj_section: item.obj_section,
          obj_section_s: item.obj_section_s,
          obj_landno: item.obj_landno,
          images: item.images,
        });
      });
      for (let index = 0; index < 6; index++) {
        if (index !== value) {
          newArray.push({ list: [] });
        } else {
          newArray.push({ list });
        }
      }
      setSectionList(newArray);
    },

    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [getExclusiveProperties, { loading: exclusivePropertiesLoading }] =
    useLazyQuery(GET_EXCLUSIVEPROPERTIES, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ exclusiveProperties }) {
        let list = [];
        let newArray = [];
        exclusiveProperties.contents.forEach((item) => {
          list.push({
            label:
              item.obj_type === "L"
                ? item.obj_city + item.obj_area + item.obj_section + "段"
                : getAddress(item.obj_city, item.obj_area, item.obj_address),
            obj_total_floor: item.obj_total_floor.toFixed(2),
            obj_land_floor: item.obj_land_floor.toFixed(2),
            obj_margin: (item.obj_margin / 10000).toFixed(2),
            obj_type: item.obj_type === "H" ? "建物" : "土地",
            obj_no: item.id,
            obj_price: item.obj_price.toFixed(2),
            obj_court: item.obj_court,
            obj_str: item.obj_str,
            obj_share: item.obj_share,
            obj_caseno: item.obj_caseno,
            obj_city: item.obj_city,
            obj_area: item.obj_area,
            obj_address: item.obj_address,
            obj_section: item.obj_section,
            obj_section_s: item.obj_section_s,
            obj_landno: item.obj_landno,
            source: item.source,
            name: item.name,
            images: item.images,
          });
        });
        for (let index = 0; index < 6; index++) {
          if (index !== value) {
            newArray.push({ list: [] });
          } else {
            newArray.push({ list });
          }
        }
        setSectionList(newArray);
      },

      onError(error) {
        Alert.alert("通知", `${error}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      },
    });

  const [addCheackNumber, { loading: addCheackNumberLoading }] = useMutation(
    ADD_CHEACKNUMBER,
    {
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  useEffect(() => {
    if (franchise) {
      getExclusiveProperties({
        variables: {
          franchiseStoreId: 1,
          enabled: true,
          pageSize: 20,
          page: 1,
        },
      });
    } else {
      let cityArray = [];
      switch (sectionName[value]) {
        case "北部":
          cityArray.push(
            "新北市",
            "臺北市",
            "基隆市",
            "新竹市",
            "桃園市",
            "新竹縣",
            "宜蘭縣"
          );
          break;
        case "中部":
          cityArray.push("臺中市", "苗栗縣", "彰化縣", "南投縣", "雲林縣");
          break;
        case "南部":
          cityArray.push("高雄市", "臺南市", "嘉義市", "嘉義縣", "屏東縣");
          break;
        case "東部":
          cityArray.push("花蓮縣", "臺東縣");
          break;
        case "離島":
          cityArray.push("澎湖縣", "金門縣", "連江縣");
          break;
        default:
          break;
      }
      getForeclosures({
        variables: {
          obj_city: cityArray,
          obj_date_ymd_from: new Date(),
          // obj_date_ymd_from: moment(new Date()).subtract(1, "year").toDate(),
          obj_date_ymd_to: moment(new Date()).add(3, "months").toDate(),
          popular: true,
          frontSite: true,
        },
      });
    }
  }, [value, franchise]);

  function getAddress(city, area, address) {
    let index;
    let newAddress;
    if (address.includes("路")) {
      index = address.indexOf("路");
    } else if (address.includes("街")) {
      index = address.indexOf("街");
    } else if (address.includes("村")) {
      index = address.indexOf("村");
    }
    newAddress = address.substring(0, index + 1);
    if (
      newAddress.includes(city) ||
      newAddress.includes(area) ||
      newAddress.includes(`台${city.substring(1, 3)}`)
    ) {
      newAddress = newAddress.replace(`台${city.substring(1, 3)}`, "");
      newAddress = newAddress.replace(city, "");
      newAddress = newAddress.replace(area, "");
    }

    return city + area + newAddress;
  }

  const chunk = (arr, amount) =>
    arr.reduce(
      (acc, e, i) => (
        i % amount ? acc[acc.length - 1].push(e) : acc.push([e]), acc
      ),
      []
    );

  const num = 8;
  const [listIndex, setListIndex] = useState(0);
  return (
    <Container className={classes.ChoicePropertyTabsRoot} maxWidth="xl">
      <Grid container>
        {
          <Grid container item xs={12}>
            <Box display="flex" alignItems="center">
              <Typography>{"熱門物件\u2002|"}</Typography>
              {!franchise && (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="none"
                  textColor="secondary"
                  scrollButtons="auto"
                  variant="scrollable"
                >
                  {sectionName.map((item, index) => {
                    return (
                      <Tab
                        label={item}
                        {...a11yProps(index)}
                        onClick={() => {
                          setListIndex(0);
                        }}
                      />
                    );
                  })}
                </Tabs>
              )}
            </Box>
          </Grid>
        }

        {/* swipable list */}
        <Grid
          item
          xs={12}
          justifyContent="center"
          style={{
            minHeight: isPhone ? "" : "680px",
          }}
        >
          <Box width="100%" mx="auto">
            {/* 各panel */}
            {sectionList?.map((item, index) => {
              return (
                <>
                  <TabPanel value={value} index={index}>
                    <Grid
                      container
                      style={{
                        margin: "4px",
                      }}
                    >
                      {/* Prev 按下之後index-1 */}
                      <Box className={classes.prevBtn}>
                        <IconButton
                          style={{
                            backgroundColor: theme.palette.grey[500],
                            color: "#fff",
                          }}
                          onClick={() => {
                            setListIndex((e) => (e < 1 ? 0 : e - 1));
                          }}
                        >
                          <ArrowBackIcon />
                        </IconButton>
                      </Box>
                      {/* Next 按下之後index+1 */}
                      <Box className={classes.nextBtn}>
                        <IconButton
                          style={{
                            backgroundColor: theme.palette.grey[500],
                            color: "#fff",
                          }}
                          onClick={() =>
                            setListIndex((e) =>
                              e === chunk(item.list, num).length - 1 ? 0 : e + 1
                            )
                          }
                        >
                          <ArrowForwardIcon />
                        </IconButton>
                      </Box>
                      <SwipeableViews
                        enableMouseEvents={true}
                        animateHeight
                        index={listIndex}
                        onChangeIndex={setListIndex}
                        style={{
                          minHeight: isTable ? "504px" : "",
                          width: "100%",
                        }}
                      >
                        {chunk(item.list, num).map((element) => {
                          return (
                            <Grid
                              container
                              spacing={1}
                              className="controlScroll"
                            >
                              {element.map((item) => {
                                return (
                                  <Grid
                                    item
                                    xs={isSmPhone ? 12 : 6}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                  >
                                    <Card className={classes.root}>
                                      <CardActionArea>
                                        <CardMedia
                                          className={classes.media}
                                          image={
                                            item.images?.length > 0
                                              ? item.images[0].imageUrl
                                              : item.obj_type === "土地"
                                              ? "/assets/images/Home/land.jpg"
                                              : "/assets/images/Home/choiceProperty.jpg"
                                          }
                                          onClick={() => {
                                            if (franchise) {
                                              window.open(
                                                `/case/${item.obj_no}`,
                                                "_blank",
                                                "noopener"
                                              );
                                              localStorage.setItem(
                                                "@fullhouseFranchise",
                                                JSON.stringify(
                                                  `${franchise ? true : false}`
                                                )
                                              );
                                              localStorage.setItem(
                                                "@fullhouse-searchType",
                                                window.location.search
                                              );
                                            } else {
                                              if (
                                                !!localStorage.getItem(
                                                  "@fullhouse-webMemberId"
                                                )
                                              ) {
                                                addCheackNumber({
                                                  variables: {
                                                    id: item.obj_no,
                                                    franchise: franchise
                                                      ? true
                                                      : false,
                                                  },
                                                });
                                                window.open(
                                                  `/case/${item.obj_no}`,
                                                  "_blank",
                                                  "noopener"
                                                );
                                                localStorage.setItem(
                                                  "@fullhouseFranchise",
                                                  JSON.stringify(
                                                    `${
                                                      franchise ? true : false
                                                    }`
                                                  )
                                                );
                                                localStorage.setItem(
                                                  "@fullhouse-searchType",
                                                  window.location.search
                                                );
                                              } else {
                                                Alert.alert(
                                                  "通知",
                                                  "請先登入才能使用！",
                                                  [
                                                    {
                                                      text: "確定",
                                                      onPress: () => {
                                                        history.replace(
                                                          "/log-in"
                                                        );
                                                      },
                                                      type: "ok",
                                                    },
                                                    {
                                                      text: "取消",
                                                      type: "cancel",
                                                    },
                                                  ]
                                                );
                                              }
                                            }
                                          }}
                                        />

                                        <CardContent
                                          style={{ padding: "8px 8px" }}
                                        >
                                          <Grid container>
                                            <Typography
                                              gutterBottom
                                              variant="h6"
                                              component="h2"
                                              className={classes.cardTitle}
                                              style={{
                                                color: "#dcba54",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {item.label}
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            container
                                            justifyContent="flex-end"
                                          >
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              onClick={() => {
                                                if (franchise) {
                                                  return onChangeTab(
                                                    `${
                                                      item.source === "法拍"
                                                        ? courtArray.find(
                                                            (item2) =>
                                                              item2.value ===
                                                              item.obj_court
                                                          )?.label ??
                                                          "" +
                                                            "(" +
                                                            item.obj_str +
                                                            item.obj_share +
                                                            item.obj_caseno +
                                                            ")" +
                                                            `${
                                                              item.obj_type ===
                                                              "建物"
                                                                ? item.obj_city +
                                                                  item.obj_area +
                                                                  item.obj_address
                                                                : item.obj_city +
                                                                  item.obj_area +
                                                                  item.obj_section +
                                                                  "段" +
                                                                  item.obj_section_s +
                                                                  (item.obj_section_s
                                                                    ? "小段"
                                                                    : "") +
                                                                  item.obj_landno +
                                                                  (item.obj_landno
                                                                    ? "地號"
                                                                    : "")
                                                            }`
                                                        : item.name
                                                    }`
                                                  );
                                                } else {
                                                  history.push("consultation", {
                                                    object:
                                                      courtArray.find(
                                                        (item2) =>
                                                          item2.value ===
                                                          item.obj_court
                                                      )?.label ??
                                                      "" +
                                                        "(" +
                                                        item.obj_str +
                                                        item.obj_share +
                                                        item.obj_caseno +
                                                        ")" +
                                                        `${
                                                          item.obj_type ===
                                                          "建物"
                                                            ? item.obj_city +
                                                              item.obj_area +
                                                              item.obj_address
                                                            : item.obj_city +
                                                              item.obj_area +
                                                              item.obj_section +
                                                              "段" +
                                                              item.obj_section_s +
                                                              (item.obj_section_s
                                                                ? "小段"
                                                                : "") +
                                                              item.obj_landno +
                                                              (item.obj_landno
                                                                ? "地號"
                                                                : "")
                                                        }`,
                                                    url: window.location
                                                      .pathname,
                                                  });
                                                }
                                              }}
                                            >
                                              我要諮詢
                                            </Button>
                                          </Grid>
                                          {item.obj_type === "建物" ? (
                                            <Typography
                                              variant="body1"
                                              color="textSecondary"
                                              component="p"
                                            >
                                              建坪：
                                              {item.obj_total_floor}坪{"\u2002"}
                                              地坪：
                                              {item.obj_land_floor}
                                              坪
                                              <br />
                                              保證金：
                                              {item.obj_margin}
                                              萬
                                              <br />
                                              類別：
                                              {item.obj_type}
                                            </Typography>
                                          ) : (
                                            <Typography
                                              variant="body1"
                                              color="textSecondary"
                                              component="p"
                                            >
                                              地坪：
                                              {item.obj_land_floor}
                                              坪
                                              <br />
                                              保證金：
                                              {item.obj_margin}
                                              萬
                                              <br />
                                              類別：
                                              {item.obj_type}
                                            </Typography>
                                          )}
                                          <Typography
                                            variant="h5"
                                            color="primary"
                                            align="right"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            {item.obj_price}萬
                                          </Typography>
                                        </CardContent>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                );
                              })}
                            </Grid>
                          );
                        })}
                      </SwipeableViews>

                      {/* list 區塊 */}
                    </Grid>
                  </TabPanel>
                </>
              );
            })}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
